module.exports = __webpack_public_path__ + "static/media/home-options-1.3297a308.webp";